import classname from 'classname';
import React from 'react';
import styles from './button.module.scss';
import { Spinner } from 'components/icons';

export default function Button({
  children,
  variant = 'plain',
  style,
  small,
  className,
  loading,
  ...rest
}) {
  const variantToClassMap = {
    primary: 'primary',
    plain: 'plain',
    dangerplain: 'dangerplain',
    danger: 'danger',
  };
  return (
    <button
      className={classname(
        styles.button,
        small ? styles.small : '',
        styles[variantToClassMap[variant]],
        className
      )}
      style={style}
      {...rest}
    >
      {loading ? (
        <Spinner
          style={{
            fill: 'transparent',
            width: '28px',
            height: '28px',
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        />
      ) : (
        children
      )}
    </button>
  );
}
